module.exports = __webpack_public_path__ + "img/recharge.4f494b3b.png";